import React from 'react';
import { useDispatch } from 'react-redux';
import { Col } from 'react-bootstrap';

import { sendAlert } from '../../actions/utils';
import { useDestroyOne } from '../../hooks';
import {
  deleteAdminLeadQuotationRequest,
  sendQuotationAdminLeadQuotationRequest
} from '../../requests/admin/leadQuotation';
import { sendQuotationLeadQuotationRequest } from '../../requests/leadQuotations';
import { BtnTooltip, IconBtn, UploadFile } from '..';
import { ModalBodyIcon } from '../Shared';

const CloseQuotation = ({ fromAdmin, lead, leadQuotation, onRequest, ...props }) => {
  const { setLeadQuotation, setModalBody, setModalShow, setMoreData, setOnRequest, setSelectedFile } = props;

  const { id, validAcceptanceKey } = leadQuotation;
  const { commercialContacts } = lead.account;

  const commercialContactEmails = commercialContacts.map(contact => contact.email);
  const stringContactEmails = commercialContactEmails.reduce((acc, current) => {
    const str = acc ? `${acc}, ` : '';
    return `${str} ${current}`;
  }, '');

  const dispatch = useDispatch();

  const { handleShowModal, OnDestroyModalComponent } = useDestroyOne({
    deleteRequest: deleteAdminLeadQuotationRequest,
    parentId: lead.id,
    modelName: 'Cotización',
    nameEndsInA: true,
    setMoreData
  });

  const handleSendQuotationRequest = () => {
    setOnRequest(true);

    const requiredFunctions = {
      dispatch,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Solicitud enviada con éxito' }));
        setLeadQuotation({ ...leadQuotation, validAcceptanceKey: true });
      },
      callback: () => {
        setOnRequest(false);
        setModalShow(false);
      }
    };

    const sendApprovalRequest = fromAdmin ? sendQuotationAdminLeadQuotationRequest : sendQuotationLeadQuotationRequest;
    return fromAdmin ? sendApprovalRequest(lead.id, id, requiredFunctions) : sendApprovalRequest(id, requiredFunctions);
  };

  const handleOnClick = () => {
    setModalShow(true);
    setModalBody(
      <ModalBodyIcon
        icon="file-add"
        highlightedText="Solicitar aprobación al cliente"
        highlightedVariant="light-warning"
        subContent={
          <>
            <p>
              Enviaremos un correo a <span>{stringContactEmails}</span> con un link donde podrá ver la cotización
              seleccionada y aprobar su contratación.
            </p>
            <p>Cuando tu cliente apruebe, esta oportunidad pasará automáticamente al cierre exitoso.</p>
          </>
        }
        handleModalClose={() => setModalShow(false)}
        formRequest={handleSendQuotationRequest}
      />
    );
  };

  return (
    <>
      <Col md={5} lg={3} className="quotation-select__request-approval d-lg-flex justify-content-lg-center px-lg-0">
        <BtnTooltip
          disabled={!stringContactEmails || onRequest || validAcceptanceKey}
          variant="secondary"
          tooltipText={!stringContactEmails ? 'Sin correo electrónico asociado' : ''}
          onClick={handleOnClick}
        >
          {validAcceptanceKey ? 'Solicitud enviada' : 'Solicitar aprobación'}
        </BtnTooltip>
      </Col>

      <Col md={fromAdmin ? 6 : 7} lg={fromAdmin ? 4 : 5}>
        <UploadFile
          abbr
          fileAccept="image/*, application/pdf"
          label="Aprobación"
          onChange={file => setSelectedFile(file)}
        />
      </Col>

      {fromAdmin && (
        <Col xs={3} md={1} className="d-flex justify-content-center mt-4">
          <IconBtn
            icon="trash"
            variant="transparent"
            className="danger"
            onClick={() => handleShowModal(leadQuotation)}
          />
        </Col>
      )}

      <OnDestroyModalComponent />
    </>
  );
};

export default CloseQuotation;
